const mt = {
  // ============================================================
  // COMMON — Komuni għall-applikazzjoni kollha
  // ============================================================
  common: {
    loading: 'Qed jillowdja...',
    error: 'Żball',
    save: 'Issejvja',
    cancel: 'Ikkanċella',
    delete: 'Ħassar',
    edit: 'Editja',
    create: 'Oħloq',
    add: 'Żid',
    remove: 'Neħħi',
    close: 'Agħlaq',
    confirm: 'Ikkonferma',
    apply: 'Applika',
    reset: 'Irrisettja',
    search: 'Fittex',
    filter: 'Iffiltra',
    clear: 'Imsaħ',
    back: 'Lura',
    next: 'Li jmiss',
    previous: 'Ta\' qabel',
    submit: 'Ibgħat',
    update: 'Aġġorna',
    refresh: 'Aġġorna',
    export: 'Esporta',
    import: 'Importa',
    download: 'Niżżel',
    upload: 'Ittella\'',
    print: 'Ipprintja',
    copy: 'Ikkopja',
    yes: 'Iva',
    no: 'Le',
    ok: 'OK',
    done: 'Lest',
    select: 'Agħżel',
    selectAll: 'Agħżel kollox',
    deselectAll: 'Neħħi l-għażla kollha',
    noResults: 'Ma nstabu l-ebda riżultati',
    noData: 'M\'hemm l-ebda dejta disponibbli',
    required: 'Meħtieġ',
    optional: 'Fakultattiv',
    actions: 'Azzjonijiet',
    details: 'Dettalji',
    overview: 'Ħarsa ġenerali',
    summary: 'Sommarju',
    total: 'Total',
    all: 'Kollha',
    none: 'Xejn',
    name: 'Isem',
    type: 'Tip',
    status: 'Stat',
    date: 'Data',
    time: 'Ħin',
    description: 'Deskrizzjoni',
    notes: 'Noti',
    comments: 'Kummenti',
    category: 'Kategorija',
    priority: 'Prijorità',
    nation: 'Nazzjon',
    country: 'Pajjiż',
    email: 'Email',
    phone: 'Telefon',
    address: 'Indirizz',
    location: 'Post',
    coordinates: 'Koordinati',
    latitude: 'Latitudni',
    longitude: 'Lonġitudni',
    from: 'Minn',
    to: 'Sa',
    createdAt: 'Maħluq',
    updatedAt: 'Aġġornat',
    createdBy: 'Maħluq minn',
    modifiedBy: 'Modifikat minn',
    active: 'Attiv',
    inactive: 'Mhux attiv',
    enabled: 'Attivat',
    disabled: 'Diżattivat',
    showing: 'Qed juri',
    of: 'minn',
    page: 'Paġna',
    perPage: 'kull paġna',
    rows: 'ringieli',
    items: 'oġġetti',
    results: 'riżultati',
    sortBy: 'Issortja skont',
    ascending: 'Tiela\'',
    descending: 'Nieżla',
    viewAll: 'Ara kollox',
    viewDetails: 'Ara d-dettalji',
    goBack: 'Mur lura',
    learnMore: 'Tgħallem aktar',
    seeMore: 'Ara aktar',
    showMore: 'Uri aktar',
    showLess: 'Uri inqas',
    expandAll: 'Espandi kollox',
    collapseAll: 'Ikkolassa kollox',
    copied: 'Ikkopjat!',
    saved: 'Issejvjat!',
    deleted: 'Imħassar!',
    updated: 'Aġġornat!',
    created: 'Maħluq!',
    success: 'Suċċess',
    warning: 'Twissija',
    info: 'Informazzjoni',
    danger: 'Periklu',
    unknown: 'Mhux magħruf',
    notAvailable: 'M/D',
    never: 'Qatt',
    today: 'Illum',
    yesterday: 'Ilbieraħ',
    tomorrow: 'Għada',
    now: 'Issa',
    ago: 'ilu',
    justNow: 'għadha kemm',
    minutesAgo: '{{count}}m ilu',
    hoursAgo: '{{count}}s ilu',
    daysAgo: '{{count}}ġ ilu',
    monthsAgo: '{{count}}x ilu',
    id: 'ID',
    version: 'Verżjoni',
    language: 'Lingwa',
    theme: 'Tema',
    darkMode: 'Modalità skura',
    lightMode: 'Modalità ċara',
    failedToLoad: 'Ma rnexxiex jillowdja d-dejta',
    failedToSave: 'Ma rnexxiex jissejvja',
    failedToDelete: 'Ma rnexxiex iħassar',
    failedToUpdate: 'Ma rnexxiex jaġġorna',
    confirmDelete: 'Int żgur li trid tħassar dan?',
    confirmAction: 'Int żgur?',
    unsavedChanges: 'Għandek bidliet li ma ġewx issejvjati. Int żgur li trid titlaq?',
    pageNotFound: '404 — Paġna mhux misjuba',
    pageNotFoundDesc: 'Il-paġna li qed tfittex ma teżistix.',
    backToDashboard: 'Lura għad-dashboard',
    characters: 'karattri',
    maxCharacters: 'Massimu ta\' {{max}} karattru',
    remaining: '{{count}} fadal',
    selected: '{{count}} magħżula',
    of_total: '{{count}} minn {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Intestatura, sidebar, menùs
  // ============================================================
  nav: {
    dashboard: 'Dashboard',
    requests: 'Talbiet',
    transports: 'Trasporti',
    myPatients: 'Il-pazjenti tiegħi',
    statistics: 'Statistika',
    flow: 'Fluss',
    resources: 'Resources',
    exercise: 'Eżerċizzju',
    administration: 'Amministrazzjoni',
    map: 'Mappa',
    info: 'Informazzjoni',
    users: 'Utenti',
    assets: 'Assi',
    hubs: 'Ċentri ta\' konnessjoni',
    treatmentFacilities: 'Faċilitajiet ta\' kura',
    patientImport: 'Importazzjoni ta\' pazjenti',
    assetTemplates: 'Templates ta\' assi',
    dayTemplates: 'Templates ta\' ġurnata',
    announcementTicker: 'Strixxa ta\' avviżi',
    exerciseStatistics: 'Statistika tal-eżerċizzju',
    settings: 'Settings',
    auditLog: 'Reġistru tal-awditjar',
    exerciseControl: 'Kontroll tal-eżerċizzju',
    dataSync: 'Sinkronizzazzjoni tad-dejta',
    documentation: 'Dokumentazzjoni',
    support: 'Sapport',
    about: 'Dwar',
    assetContracts: 'Asset Contracts',
    notifications: 'Notifiki',
    schedules: 'Skedi',
    capacityPlanning: 'Ippjanar tal-kapaċità',
    transportPlanning: 'Ippjanar tat-trasport',
    transportBooking: 'Ibbukkjar tat-trasport',
    flowDiagram: 'Dijagramma tal-fluss',
    changePassword: 'Ibdel il-password',
    missions: 'Missjonijiet',
    startPoints: 'Punti tat-tluq',
    hospital: 'Sptar',
  },

  // ============================================================
  // AUTH — Login, password, sessjoni
  // ============================================================
  auth: {
    login: 'Idħol',
    logout: 'Oħroġ',
    logoutNow: 'Oħroġ issa',
    loggingIn: 'Qed tidħol...',
    loginFailed: 'Id-dħul ma rnexxiex',
    email: 'Email',
    password: 'Password',
    username: 'Isem tal-utent',
    enterEmail: 'Daħħal l-indirizz tal-email tiegħek',
    enterPassword: 'Daħħal il-password tiegħek',
    enterUsername: 'Daħħal l-isem tal-utent tiegħek',
    forgotPassword: 'Insejt il-password?',
    forgotPasswordTitle: 'Password minsija',
    forgotPasswordDesc: 'Daħħal l-isem tal-utent u l-indirizz tal-email tiegħek. Jekk it-tnejn jaqblu, l-amministraturi jiġu notifikati biex jirrisettjaw il-password tiegħek.',
    requestPasswordReset: 'Itlob reset tal-password',
    sending: 'Qed jibgħat...',
    backToLogin: 'Lura għal-login',
    pleaseWait: 'Jekk jogħġbok, stenna qabel ma terġa\' tipprova.',
    requestFailed: 'It-talba fallit',
    credentialsMatch: 'Jekk il-kredenzjali jaqblu, l-amministraturi ġew notifikati.',
    forAccess: 'Għall-aċċess, jekk jogħġbok ikkuntattja l-amministratur tas-sistema.',
    changePassword: 'Ibdel il-password',
    currentPassword: 'Password attwali',
    newPassword: 'Password ġdida',
    confirmPassword: 'Ikkonferma l-password',
    passwordChanged: 'Il-password inbidlet b\'suċċess',
    passwordMismatch: 'Il-passwords ma jaqblux',
    passwordTooShort: 'Il-password trid tkun tal-anqas 8 karattri',
    changingPassword: 'Qed jinbidel...',
    mustChangePassword: 'Trid tibdel il-password tiegħek qabel ma tkompli.',
    sessionExpiring: 'Is-sessjoni qed tiskadi',
    sessionExpireText: 'Is-sessjoni tiegħek tiskadi fi <strong>{{time}}</strong>. Jekk jogħġbok, issejvja x-xogħol tiegħek u erġa\' idħol biex tkompli.',
    dismiss: 'Warrab',
    switchNation: 'Ibdel in-nazzjon',
    returnTo: 'Lura għal-{{nation}}',
    viewingAs: 'Qed tara bħala',
    loggedInAs: 'dħalt bħala {{nation}}',
    trainingMode: 'GĦAL SKOPIJIET TA\' TAĦRIĠ BISS',
    dedication: 'Maħluq bl-imħabba u d-dedikazzjoni għall-professjoni',
  },

  // ============================================================
  // ROLES — Rwoli tal-utenti u tikketti
  // ============================================================
  roles: {
    admin: 'Amministratur tas-sistema',
    excon: 'Kontrollur tal-eżerċizzju',
    eu: 'Koordinatur tal-UE',
    planner: 'Ippjanatur',
    hub: 'Maniġer taċ-ċentru',
    nation: 'Nazzjon',
    readOnly: 'Qari biss',
    systemAdmin: 'Amministratur tas-sistema',
    transportPlanner: 'Ippjanatur tat-trasport',
    systemRoles: 'Rwoli tas-sistema',
  },

  // ============================================================
  // STATUS — Stati ta' talbiet, offerti, missjonijiet
  // ============================================================
  status: {
    draft: 'Abbozz',
    underReview: 'Taħt reviżjoni',
    published: 'Ippubblikat',
    underSelection: 'Taħt selezzjoni',
    accepted: 'Aċċettat',
    planned: 'Ippjanat',
    inTransit: 'Fit-transitu',
    completed: 'Komplet',
    closed: 'Magħluq',
    withdrawn: 'Irtirat',
    pending: 'Pendenti',
    rejected: 'Irrifjutat',
    cancelled: 'Ikkanċellat',
    active: 'Attiv',
    inactive: 'Mhux attiv',
    review: 'Reviżjoni',
    selection: 'Selezzjoni',
    transit: 'Transitu',
  },

  // ============================================================
  // CATEGORIES — Kategoriji ta' talbiet
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Persunal',
    material: 'Materjal',
    equipment: 'Tagħmir',
    other: 'Oħrajn',
    news: 'Aħbarijiet',
  },

  // ============================================================
  // URGENCY — Livelli ta' urġenza
  // ============================================================
  urgency: {
    routine: 'Rutina',
    priority: 'Prijorità',
    urgent: 'Urġenti',
    immediate: 'Immedjat',
  },

  // ============================================================
  // ASSETS — Tipi ta' assi tat-trasport
  // ============================================================
  assetTypes: {
    train: 'Ferrovija',
    ship: 'Vapur',
    aircraft: 'Ajruplan',
    bus: 'Karozza tal-linja',
    ambulance: 'Ambulanza',
    drone: 'Dron',
    helicopter: 'Ħelikopter',
    ferry: 'Lanċa',
    other: 'Oħrajn',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Dashboard',
    goodMorning: 'Bonġu',
    goodAfternoon: 'Il-ġurnata t-tajba',
    goodEvening: 'Il-lejla t-tajba',
    lastLogin: 'L-aħħar dħul',
    infrastructure: 'Infrastruttura',
    transportAssets: 'Assi tat-trasport',
    treatmentFacilities: 'Faċilitajiet ta\' kura',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Statistika tat-talbiet',
    viewAllRequests: 'Ara t-talbiet kollha',
    availableAssets: 'Assi disponibbli',
    seated: 'Bilqiegħda',
    lying: 'Mimduda',
    intensive: 'Kura intensiva',
    notifications: 'Notifiki',
    markAllRead: 'Immarka kollox bħala moqri',
    noNotifications: 'Għad m\'hemm l-ebda notifiki',
    notifiedWhenActivity: 'Tiġi notifikat meta jkun hemm attività ġdida',
    viewDetailsBtn: 'Ara d-dettalji',
    nationUsers: 'Utenti tan-nazzjon',
    user: 'Utent',
    roles: 'Rwoli',
    noUsersFound: 'Ma nstabu l-ebda utenti',
    participatingNations: 'Nazzjonijiet parteċipanti',
    exerciseDisclaimer: 'Dan is-sistema huwa għall-użu ta\' eżerċizzju biss. Daħħal dejta ta\' eżerċizzju simulat biss. Il-flussi tax-xogħol huma adattati għax-xenarju tal-eżerċizzju u jistgħu jkunu differenti mill-proċeduri reali. Ir-regoli ta\' sigurtà tal-IT u l-protezzjoni tad-dejta jibqgħu applikabbli għal kollox.',
    notConfigured: 'Mhux ikkonfigurat',
    requestCount: '{{count}} talba/talbiet',
    clickToView: 'Ikklikkja biex tara',
    systemAdministration: 'Amministrazzjoni tas-sistema',
    exerciseControlTitle: 'Kontroll tal-eżerċizzju',
    euCoordination: 'Koordinament tal-UE',
    transportPlanningTitle: 'Ippjanar tat-trasport',
    hubManagement: 'Ġestjoni taċ-ċentri',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Talba ġdida',
    myDrafts: 'L-abbozzi tiegħi',
    pendingReview: 'Pendenti għal reviżjoni',
    activeTransports: 'Trasporti attivi',
    myPatients: 'Il-pazjenti tiegħi',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Talbiet',
    newRequest: 'Talba ġdida',
    createRequest: 'Oħloq talba',
    editRequest: 'Editja talba',
    requestDetail: 'Dettalj tat-talba',
    requestId: 'ID tat-talba',
    fromNation: 'Min-nazzjon',
    toNation: 'Għan-nazzjon',
    requestingNation: 'Nazzjon li qed titlob',
    receivingNation: 'Nazzjon li qed tirċievi',
    category: 'Kategorija',
    urgency: 'Urġenza',
    status: 'Stat',
    patients: 'Pazjenti',
    patientCount: 'Għadd ta\' pazjenti',
    offers: 'Offerti',
    offerCount: 'Għadd ta\' offerti',
    created: 'Maħluq',
    updated: 'Aġġornat',
    submittedBy: 'Sottomess minn',
    reviewedBy: 'Reviżjonat minn',
    description: 'Deskrizzjoni',
    medicalDetails: 'Dettalji mediċi',
    transportDetails: 'Dettalji tat-trasport',
    additionalInfo: 'Informazzjoni addizzjonali',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Punt tat-tluq',
    arrivalPoint: 'Punt tal-wasla',
    estimatedDeparture: 'Tluq stmat',
    estimatedArrival: 'Wasla stmata',
    submitForReview: 'Ibgħat għal reviżjoni',
    publish: 'Ippubblika',
    startSelection: 'Ibda s-selezzjoni',
    acceptOffer: 'Aċċetta l-offerta',
    markInTransit: 'Immarka fit-transitu',
    markCompleted: 'Immarka bħala komplet',
    closeRequest: 'Agħlaq it-talba',
    withdrawRequest: 'Irtira t-talba',
    withdraw: 'Irtira',
    revertToDraft: 'Erġa\' lura għall-abbozz',
    deleteRequest: 'Ħassar it-talba',
    duplicateRequest: 'Idduplika t-talba',
    createFollowUp: 'Oħloq talba konsolidata',
    followUpRequest: 'Talba konsolidata',
    parentRequest: 'Talba oriġinali',
    childRequests: 'Talbiet konsolidati',
    noRequests: 'Ma nstabu l-ebda talbiet',
    noOffers: 'Għad m\'hemm l-ebda offerti',
    addPatient: 'Żid pazjent',
    removePatient: 'Neħħi pazjent',
    patientDetails: 'Dettalji tal-pazjent',
    contactPerson: 'Persuna ta\' kuntatt',
    contactPhone: 'Telefon ta\' kuntatt',
    contactEmail: 'Email ta\' kuntatt',
    specialRequirements: 'Rekwiżiti speċjali',
    medicalEquipment: 'Tagħmir mediku',
    accompaniment: 'Akkumpanjament',
    timeline: 'Kronoloġija',
    history: 'Storja',
    addComment: 'Żid kumment',
    writeComment: 'Ikteb kumment...',
    postComment: 'Ippowstja kumment',
    posting: 'Qed jippowstja...',
    noComments: 'Għad m\'hemm l-ebda kummenti',
    coverageBar: 'Kopertura',
    covered: 'kopert',
    uncovered: 'mhux kopert',
    filterByStatus: 'Iffiltra skont l-istat',
    filterByCategory: 'Iffiltra skont il-kategorija',
    filterByNation: 'Iffiltra skont in-nazzjon',
    searchRequests: 'Fittex talbiet...',
    confirmWithdraw: 'Int żgur li trid tirtira din it-talba?',
    confirmDelete: 'Int żgur li trid tħassar din it-talba?',
    confirmPublish: 'Int żgur li trid tippubblika din it-talba? Tkun viżibbli għan-nazzjonijiet kollha.',
    confirmStartSelection: 'Int żgur li trid tibda s-selezzjoni? In-nazzjonijiet ikunu jistgħu jagħmlu offerti.',
    warningStartSelection: 'Li tibda s-selezzjoni tagħmel din it-talba viżibbli għan-nazzjonijiet parteċipanti kollha. Ikunu jistgħu jissottomettu offerti għall-pazjenti f\'din it-talba. Din l-azzjoni ma tistax tiġi annullata.',
    warningMakeOffer: 'Billi tissottometti din l-offerta, qed tintrabat għan-nazzjon tiegħek biex tipprovdi l-assistenza proposta. Din l-azzjoni tinnotifika n-nazzjon li qed titlob u l-kontroll tal-eżerċizzju.',
    saveDraft: 'Issejvja l-abbozz',
    saving: 'Qed jissejvja...',
    saveAndSubmit: 'Issejvja u ibgħat',
    step: 'Pass {{number}}',
    generalInfo: 'Informazzjoni ġenerali',
    patientInfo: 'Informazzjoni tal-pazjent',
    logisticsInfo: 'Informazzjoni loġistika',
    reviewSubmit: 'Irrevedi u ibgħat',
    requestTitle: 'Titlu tat-talba',
    requestDescription: 'Deskrizzjoni tat-talba',
    numberOfPatients: 'Għadd ta\' pazjenti',
    typeOfAssistance: 'Tip ta\' assistenza',
    medicalTreatment: 'Kura medika',
    transportAssistance: 'Assistenza tat-trasport',
    both: 'It-tnejn',
    treatmentOnly: 'Kura biss',
    transportOnly: 'Trasport biss',
    validationErrors: 'Jekk jogħġbok, ikkoreġi l-iżbalji li ġejjin:',
    fieldRequired: 'Dan il-qasam huwa meħtieġ',
    selectExitHub: 'Agħżel ċentru ta\' ħruġ',
    createExitHub: 'Oħloq ċentru ta\' ħruġ',
    backToRequests: 'Lura għat-talbiet',
    noRequestsFound: 'Ma nstabu l-ebda talbiet',
    createFirstRequest: 'Oħloq l-ewwel talba tiegħek biex tibda',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Offerti',
    createOffer: 'Oħloq offerta',
    makeOffer: 'Agħmel offerta',
    manageOffers: 'Immaniġġja l-offerti',
    offerDetail: 'Dettalj tal-offerta',
    offerId: 'ID tal-offerta',
    offeringNation: 'Nazzjon li qed toffri',
    offerType: 'Tip ta\' offerta',
    treatment: 'Kura',
    transport: 'Trasport',
    combined: 'Kombinata',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Offerta ta\' kura',
    transportOffer: 'Offerta ta\' trasport',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Agħżel pazjenti',
    selectedPatients: 'Pazjenti magħżula',
    patientSelection: 'Selezzjoni ta\' pazjenti',
    offerConfiguration: 'Konfigurazzjoni tal-offerta',
    reviewOffer: 'Irrevedi l-offerta',
    submitOffer: 'Ibgħat l-offerta',
    submitting: 'Qed jibgħat...',
    acceptOffer: 'Aċċetta l-offerta',
    rejectOffer: 'Irrifjuta l-offerta',
    withdrawOffer: 'Irtira l-offerta',
    noOffers: 'M\'hemm l-ebda offerti disponibbli',
    noOffer: 'No Offer',
    offerStatus: 'Stat tal-offerta',
    offerDate: 'Data tal-offerta',
    transportAsset: 'Ass tat-trasport',
    departureDate: 'Data tat-tluq',
    arrivalDate: 'Data tal-wasla',
    treatmentFacility: 'Faċilità ta\' kura',
    capacity: 'Kapaċità',
    availableCapacity: 'Kapaċità disponibbli',
    totalCapacity: 'Kapaċità totali',
    selectAsset: 'Agħżel ass',
    selectFacility: 'Agħżel faċilità',
    offerNotes: 'Noti tal-offerta',
    confirmAccept: 'Int żgur li trid taċċetta din l-offerta?',
    confirmReject: 'Int żgur li trid tirrifjuta din l-offerta?',
    extendTransport: 'Estendi t-trasport',
    transportExtension: 'Estensjoni tat-trasport',
    comparisonView: 'Vista komparattiva',
    shortlist: 'Lista qasira',
    addToShortlist: 'Żid mal-lista qasira',
    removeFromShortlist: 'Neħħi mil-lista qasira',
    leaveConfirmTitle: 'Titlaq minn din il-paġna?',
    leaveConfirmMessage: 'Għandek bidliet li ma ġewx issejvjati. Int żgur li trid titlaq?',
    stayOnPage: 'Ibqa\' fuq il-paġna',
    leavePage: 'Itlaq mill-paġna',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Trasporti',
    missionDetail: 'Dettalj tat-trasport',
    missionId: 'ID tat-trasport',
    missionStatus: 'Stat tat-trasport',
    createMission: 'Oħloq trasport',
    overview: 'Ħarsa ġenerali',
    patientsTab: 'Pazjenti',
    transportsTab: 'Partijiet tat-trasport',
    treatmentTab: 'Kura',
    reviewTab: 'Reviżjoni',
    departure: 'Tluq',
    arrival: 'Wasla',
    origin: 'Oriġini',
    destination: 'Destinazzjoni',
    stops: 'Waqfiet',
    addStop: 'Żid waqfa',
    removeStop: 'Neħħi waqfa',
    stopName: 'Isem tal-waqfa',
    stopType: 'Tip tal-waqfa',
    estimatedTime: 'Ħin stmat',
    actualTime: 'Ħin reali',
    asset: 'Ass',
    driver: 'Sewwieq',
    crew: 'Ekwipaġġ',
    noMissions: 'Ma nstabu l-ebda trasporti',
    completeMission: 'Ikkompl​eta t-trasport',
    cancelMission: 'Ikkanċella t-trasport',
    startTransport: 'Ibda t-trasport',
    missionChain: 'Katina tat-trasport',
    linkedMissions: 'Trasporti marbuta',
    handover: 'Konsenja',
    handoverPoint: 'Punt tal-konsenja',
    pickupPoint: 'Punt tat-telliegħa',
    dropoffPoint: 'Punt tan-niżżla',
    searchTransports: 'Fittex trasporti...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pazjenti',
    myPatients: 'Il-pazjenti tiegħi',
    patientId: 'ID tal-pazjent',
    firstName: 'Isem',
    lastName: 'Kunjom',
    dateOfBirth: 'Data tat-twelid',
    age: 'Età',
    gender: 'Sess',
    male: 'Raġel',
    female: 'Mara',
    other: 'Ieħor',
    nationality: 'Nazzjonalità',
    diagnosis: 'Dijanjożi',
    condition: 'Kundizzjoni',
    stable: 'Stabbli',
    critical: 'Kritiku',
    serious: 'Serju',
    treatmentNeeded: 'Kura meħtieġa',
    allergies: 'Allerġiji',
    medications: 'Mediċini',
    bloodType: 'Grupp tad-demm',
    weight: 'Piż (kg)',
    infectious: 'Infettiv',
    mentalHealth: 'Saħħa mentali',
    mobility: 'Mobilità',
    ambulatory: 'Ambulatorju',
    wheelchair: 'Siġġu tar-roti',
    stretcher: 'Stretcher',
    intensive: 'Kura intensiva',
    oxygenRequired: 'Ossiġenu meħtieġ',
    ventilator: 'Ventilatur',
    medicalEscort: 'Skorta medika',
    noPatients: 'Ma nstabu l-ebda pazjenti',
    patientDetails: 'Dettalji tal-pazjent',
    medicalHistory: 'Storja medika',
    travelDocuments: 'Dokumenti tal-ivvjaġġar',
    passport: 'Passaport',
    pseudonymizedId: 'ID pseudonimizzat',
    sensitiveData: 'Dejta sensittiva',
    journey: 'Vjaġġ tal-pazjent',
    assignedTo: 'Assenjat lil',
    currentLocation: 'Post attwali',
    importPatients: 'Importa pazjenti',
    exportPatients: 'Esporta pazjenti',
    seated: 'Bilqiegħda',
    lying: 'Mimdud',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Utenti',
    createUser: 'Oħloq utent',
    editUser: 'Editja utent',
    deleteUser: 'Ħassar utent',
    username: 'Isem tal-utent',
    displayName: 'Isem li jidher',
    email: 'Email',
    password: 'Password',
    role: 'Rwol',
    roles: 'Rwoli',
    nation: 'Nazzjon',
    active: 'Attiv',
    lastLogin: 'L-aħħar dħul',
    createdAt: 'Maħluq',
    isNation: 'Nazzjon',
    isEU: 'UE',
    isAdmin: 'Amministratur',
    isExcon: 'EXCON',
    isPlanner: 'Ippjanatur',
    isHub: 'Ċentru',
    isReadOnly: 'Qari biss',
    noUsers: 'Ma nstabu l-ebda utenti',
    confirmDelete: 'Int żgur li trid tħassar dan l-utent?',
    resetPassword: 'Irrisettja l-password',
    generatePassword: 'Iġġenera password',
    searchUsers: 'Fittex utenti...',
    userCreated: 'L-utent inħoloq b\'suċċess',
    userUpdated: 'L-utent ġie aġġornat b\'suċċess',
    userDeleted: 'L-utent tħassar b\'suċċess',
    selectNation: 'Agħżel nazzjon',
    mustChangePassword: 'Irid jibdel il-password fid-dħul li jmiss',
    flagImage: 'Stampa tal-bandiera',
    exportUsers: 'Esporta utenti',
    importUsers: 'Importa utenti',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Assi',
    createAsset: 'Oħloq ass',
    editAsset: 'Editja ass',
    deleteAsset: 'Ħassar ass',
    assetName: 'Isem tal-ass',
    assetType: 'Tip ta\' ass',
    capacitySeated: 'Kapaċità (bilqiegħda)',
    capacityLying: 'Kapaċità (mimduda)',
    capacityIntensive: 'Kapaċità (kura intensiva)',
    owner: 'Sid',
    operator: 'Operatur',
    baseLocation: 'Post bażi',
    range: 'Firxa',
    speed: 'Veloċità',
    noAssets: 'Ma nstabu l-ebda assi',
    confirmDelete: 'Int żgur li trid tħassar dan l-ass?',
    searchAssets: 'Fittex assi...',
    assetCreated: 'L-ass inħoloq b\'suċċess',
    assetUpdated: 'L-ass ġie aġġornat b\'suċċess',
    assetDeleted: 'L-ass tħassar b\'suċċess',
    exportAssets: 'Esporta assi',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Ċentri ta\' konnessjoni',
    startPoints: 'Punti tat-tluq',
    createHub: 'Oħloq ċentru',
    editHub: 'Editja ċentru',
    deleteHub: 'Ħassar ċentru',
    hubName: 'Isem taċ-ċentru',
    hubType: 'Tip taċ-ċentru',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Ċentru ta\' dħul',
    airport: 'Ajruport',
    seaport: 'Port marittimu',
    railStation: 'Stazzjon tal-ferrovija',
    roadPoint: 'Punt tat-triq',
    ucpmClassification: 'Klassifikazzjoni UCPM',
    icaoCode: 'Kodiċi ICAO',
    iataCode: 'Kodiċi IATA',
    noHubs: 'Ma nstabu l-ebda ċentri',
    confirmDelete: 'Int żgur li trid tħassar dan iċ-ċentru?',
    searchHubs: 'Fittex ċentri...',
    nationAssignment: 'Assenjament ta\' nazzjonijiet',
    assignNations: 'Asenja nazzjonijiet',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Faċilitajiet ta\' kura',
    createFacility: 'Oħloq faċilità',
    editFacility: 'Editja faċilità',
    deleteFacility: 'Ħassar faċilità',
    facilityName: 'Isem tal-faċilità',
    facilityType: 'Tip tal-faċilità',
    hospitalName: 'Isem tal-isptar',
    bedCapacity: 'Kapaċità tas-sodod',
    specialties: 'Speċjalitajiet',
    availableBeds: 'Sodod disponibbli',
    totalBeds: 'Total tas-sodod',
    contactPerson: 'Persuna ta\' kuntatt',
    noFacilities: 'Ma nstabu l-ebda faċilitajiet ta\' kura',
    confirmDelete: 'Int żgur li trid tħassar din il-faċilità?',
    searchFacilities: 'Fittex faċilitajiet...',
    hubNationAssignment: 'Assenjament ta\' nazzjonijiet liċ-ċentri',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Skedi',
    createSchedule: 'Oħloq skeda',
    editSchedule: 'Editja skeda',
    deleteSchedule: 'Ħassar skeda',
    scheduleName: 'Isem tal-iskeda',
    scheduleType: 'Tip tal-iskeda',
    recurring: 'Rikorrenti',
    oneTime: 'Darba waħda',
    frequency: 'Frekwenza',
    daily: 'Kuljum',
    weekly: 'Kull ġimgħa',
    startDate: 'Data tal-bidu',
    endDate: 'Data tat-tmiem',
    departureTime: 'Ħin tat-tluq',
    arrivalTime: 'Ħin tal-wasla',
    stops: 'Waqfiet',
    addStop: 'Żid waqfa',
    noSchedules: 'Ma nstabu l-ebda skedi',
    bookings: 'Prenotazzjonijiet',
    timeline: 'Kronoloġija',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Notifiki',
    markAllRead: 'Immarka kollox bħala moqri',
    markAsRead: 'Immarka bħala moqri',
    markAsUnread: 'Immarka bħala mhux moqri',
    noNotifications: 'M\'hemm l-ebda notifiki',
    viewAll: 'Ara n-notifiki kollha',
    settings: 'Settings tan-notifiki',
    emailNotifications: 'Notifiki bl-email',
    inAppNotifications: 'Notifiki fl-applikazzjoni',
    notifyOn: 'Innotifikani dwar',
    requestCreated: 'Talba ġdida',
    requestPublished: 'Talba ppubblikata',
    requestClosed: 'Talba magħluqa',
    requestCompleted: 'Talba kompleta',
    commentAdded: 'Kumment ġdid',
    offerReceived: 'Offerta riċevuta',
    offerAccepted: 'Offerta aċċettata',
    statusChanged: 'L-istat inbidel',
    selectionStarted: 'Selezzjoni mibdija',
    missionCreated: 'Trasport maħluq',
    missionStatusUpdated: 'Trasport aġġornat',
    transportPartnerNamed: 'Sieħeb tat-trasport',
    transportExtensionReceived: 'Estensjoni tat-trasport',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Settings',
    general: 'Ġenerali',
    system: 'Sistema',
    email: 'Email',
    sync: 'Sinkronizzazzjoni',
    security: 'Sigurtà',
    appearance: 'Apparenza',
    systemName: 'Isem tas-sistema',
    systemEmail: 'Email tas-sistema',
    maintenanceMode: 'Modalità ta\' manutenzjoni',
    readOnlyMode: 'Modalità ta\' qari biss',
    emailEnabled: 'Email attivat',
    smtpHost: 'Server SMTP',
    smtpPort: 'Port SMTP',
    smtpUser: 'Utent SMTP',
    smtpPassword: 'Password SMTP',
    senderEmail: 'Email tal-mittent',
    senderName: 'Isem tal-mittent',
    testEmail: 'Ibgħat email ta\' prova',
    syncEnabled: 'Sinkronizzazzjoni attivata',
    syncUrl: 'URL tas-sinkronizzazzjoni',
    syncApiKey: 'Ċavetta API tas-sinkronizzazzjoni',
    settingsSaved: 'Is-settings ġew issejvjati b\'suċċess',
    helpdesk: 'Helpdesk',
    helpdeskTitle: 'Titlu tal-helpdesk',
    helpdeskEmail: 'Email tal-helpdesk',
    helpdeskPhone: 'Telefon tal-helpdesk',
    helpdeskInfo: 'Informazzjoni tal-helpdesk',
    realLifeSupport: 'Sapport f\'sitwazzjoni reali',
    trainingMode: 'Modalità ta\' taħriġ',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Reġistri tal-awditjar',
    action: 'Azzjoni',
    user: 'Utent',
    target: 'Mira',
    details: 'Dettalji',
    timestamp: 'Marka tal-ħin',
    ipAddress: 'Indirizz IP',
    noLogs: 'Ma nstabu l-ebda reġistri tal-awditjar',
    searchLogs: 'Fittex reġistri...',
    filterByAction: 'Iffiltra skont l-azzjoni',
    filterByUser: 'Iffiltra skont l-utent',
    exportLogs: 'Esporta r-reġistri',
    exportCsv: 'Esporta CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Kontroll tal-eżerċizzju',
    currentDay: 'Ġurnata attwali',
    exerciseDay: 'Ġurnata tal-eżerċizzju',
    nextDay: 'Ġurnata li jmiss',
    previousDay: 'Ġurnata ta\' qabel',
    resetExercise: 'Irrisettja l-eżerċizzju',
    startExercise: 'Ibda l-eżerċizzju',
    endExercise: 'Temm l-eżerċizzju',
    dayReset: 'Reset tal-ġurnata',
    confirmReset: 'Int żgur li trid tirrisettja l-ġurnata tal-eżerċizzju? Dan iħassar id-dejta kollha tal-ġurnata attwali.',
    resetInProgress: 'Ir-reset qed isir...',
    maintenanceMode: 'Modalità ta\' manutenzjoni',
    enableMaintenance: 'Attiva l-manutenzjoni',
    disableMaintenance: 'Diżattiva l-manutenzjoni',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Sinkronizzazzjoni tad-dejta',
    syncStatus: 'Stat tas-sinkronizzazzjoni',
    lastSync: 'L-aħħar sinkronizzazzjoni',
    pendingItems: 'Oġġetti pendenti',
    syncNow: 'Issinkronizza issa',
    syncing: 'Qed jissinkronizza...',
    syncSuccess: 'Is-sinkronizzazzjoni tlestiet b\'suċċess',
    syncFailed: 'Is-sinkronizzazzjoni fallit',
    outbox: 'Kaxxa tal-ħruġ',
    inbox: 'Kaxxa tad-dħul',
    configuration: 'Konfigurazzjoni',
    targetUrl: 'URL tad-destinazzjoni',
    apiKey: 'Ċavetta API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Mappa',
    layers: 'Saffi',
    requests: 'Talbiet',
    hubs: 'Ċentri',
    facilities: 'Faċilitajiet',
    routes: 'Rotot',
    showAll: 'Uri kollox',
    hideAll: 'Aħbi kollox',
    zoomIn: 'Kabbar',
    zoomOut: 'Żgħir',
    resetView: 'Irrisettja l-vista',
    satellite: 'Satellita',
    terrain: 'Terren',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'It-tiles tal-mappa qed jiġu servuti lokalment',
    tilesOnline: 'It-tiles tal-mappa qed jillowdjaw minn servers online',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistika',
    overview: 'Ħarsa ġenerali',
    requestsByStatus: 'Talbiet skont l-istat',
    requestsByCategory: 'Talbiet skont il-kategorija',
    requestsByNation: 'Talbiet skont in-nazzjon',
    offersByStatus: 'Offerti skont l-istat',
    patientsByCondition: 'Pazjenti skont il-kundizzjoni',
    transportsByStatus: 'Trasporti skont l-istat',
    timeline: 'Kronoloġija',
    totalRequests: 'Total ta\' talbiet',
    totalOffers: 'Total ta\' offerti',
    totalPatients: 'Total ta\' pazjenti',
    totalTransports: 'Total ta\' trasporti',
    averageResponseTime: 'Ħin medju ta\' risposta',
    completionRate: 'Rata ta\' tlestija',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Statistika tal-eżerċizzju',
    overview: 'Ħarsa ġenerali',
    byCategory: 'Skont il-kategorija',
    byNation: 'Skont in-nazzjon',
    byDay: 'Skont il-ġurnata',
    totalPatientsMoved: 'Total ta\' pazjenti mċaqalqa',
    totalRequestsProcessed: 'Total ta\' talbiet ipproċessati',
    averageProcessingTime: 'Ħin medju ta\' pproċessar',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Dijagramma tal-fluss',
    sankey: 'Sankey',
    nodeGraph: 'Graf tan-nodi',
    refresh: 'Aġġorna',
    noData: 'M\'hemm l-ebda dejta ta\' fluss disponibbli',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Dwar',
    version: 'Verżjoni',
    systemInfo: 'Informazzjoni tas-sistema',
    buildDate: 'Data tal-bini',
    environment: 'Ambjent',
    description: 'ARCOS — Sistema Avvanzata ta\' Komunikazzjoni ta\' Talbiet',
    subtitle: 'Assistenza għall-Vittmi u Operazzjonijiet Mediċi',
    whatIsArcos: 'X\'inhu ARCOS? – Spjegazzjoni għall-parteċipanti fl-eżerċizzju',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Appoġġjat minn MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – fejn il-kurżità tiltaqa\' mal-kollaborazzjoni.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentazzjoni',
    gettingStarted: 'Kif tibda',
    userGuide: 'Gwida tal-utent',
    faq: 'Mistoqsijiet frekwenti',
    troubleshooting: 'Soluzzjoni tal-problemi',
    apiReference: 'Referenza tal-API',
    downloadTemplate: 'Niżżel template',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Importazzjoni ta\' pazjenti',
    uploadFile: 'Ittella\' fajl',
    selectFile: 'Agħżel fajl',
    preview: 'Ħarsa ta\' qabel',
    importNow: 'Importa issa',
    importing: 'Qed jimporta...',
    importSuccess: '{{count}} pazjent(i) importati b\'suċċess',
    importFailed: 'L-importazzjoni fallit',
    downloadTemplate: 'Niżżel template',
    dragDrop: 'Ikkaxkra u itfa\' fajl hawn, jew ikklikkja biex tagħżel',
    supportedFormats: 'Formati supportati: XLSX, XLS, CSV',
    rowsFound: '{{count}} ringieli misjuba',
    validRows: '{{count}} ringieli validi',
    invalidRows: '{{count}} ringieli invalidi',
    duplicateRows: '{{count}} ringieli duplikati',
    previewData: 'Ħarsa ta\' qabel tad-dejta',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Ippjanar tat-trasport',
    planRoute: 'Ippjana rotta',
    routeBuilder: 'Bennej tar-rotot',
    addWaypoint: 'Żid punt intermedju',
    removeWaypoint: 'Neħħi punt intermedju',
    estimatedDuration: 'Tul ta\' żmien stmat',
    distance: 'Distanza',
    selectVehicle: 'Agħżel vettura',
  },

  transportBooking: {
    title: 'Ibbukkjar tat-trasport',
    bookTransport: 'Ibbukkja trasport',
    availableSlots: 'Postijiet disponibbli',
    bookingConfirmed: 'Il-prenotazzjoni kkonfermata',
    cancelBooking: 'Ikkanċella l-prenotazzjoni',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Ippjanar tal-kapaċità',
    totalCapacity: 'Kapaċità totali',
    usedCapacity: 'Kapaċità użata',
    availableCapacity: 'Kapaċità disponibbli',
    utilizationRate: 'Rata ta\' użu',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Templates ta\' assi',
    dayTemplates: 'Templates ta\' ġurnata',
    createTemplate: 'Oħloq template',
    editTemplate: 'Editja template',
    deleteTemplate: 'Ħassar template',
    templateName: 'Isem tat-template',
    applyTemplate: 'Applika template',
    noTemplates: 'Ma nstabu l-ebda templates',
    confirmDelete: 'Int żgur li trid tħassar dan it-template?',
    confirmApply: 'Int żgur li trid tapplika dan it-template? Dan jikteb fuq id-dejta eżistenti.',
    exportTemplates: 'Esporta templates',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Strixxa ta\' avviżi',
    createAnnouncement: 'Oħloq avviż',
    editAnnouncement: 'Editja avviż',
    deleteAnnouncement: 'Ħassar avviż',
    message: 'Messaġġ',
    startTime: 'Ħin tal-bidu',
    endTime: 'Ħin tat-tmiem',
    active: 'Attiv',
    noAnnouncements: 'M\'hemm l-ebda avviżi',
    confirmDelete: 'Int żgur li trid tħassar dan l-avviż?',
  },

  // ============================================================
  // COMPONENTS — Strings ta' komponenti li jerġgħu jintużaw
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Fittex...',
      noResults: 'Ma nstabu l-ebda riżultati',
      showing: 'Qed juri {{from}} sa {{to}} minn {{total}}',
      rowsPerPage: 'Ringieli kull paġna',
      previousPage: 'Paġna ta\' qabel',
      nextPage: 'Paġna li jmiss',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Ikkonferma',
      cancel: 'Ikkanċella',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Bidliet mhux issejvjati',
      message: 'Għandek bidliet li ma ġewx issejvjati. Int żgur li trid titlaq minn din il-paġna?',
      stay: 'Ibqa\' fuq il-paġna',
      leave: 'Itlaq mill-paġna',
    },
    // EmptyState
    emptyState: {
      noData: 'M\'hemm l-ebda dejta disponibbli',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Xi ħaġa marret ħażin',
      message: 'Seħħ żball mhux mistenni. Jekk jogħġbok, ipprova aġġorna l-paġna.',
      retry: 'Erġa\' pprova',
    },
    // ExportButton
    exportButton: {
      export: 'Esporta',
      exporting: 'Qed jesporta...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Ipprintja',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Abbozz',
      review: 'Reviżjoni',
      published: 'Ippubblikat',
      selection: 'Selezzjoni',
      inTransit: 'Fit-transitu',
      completed: 'Komplet',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Istanza online',
      message: 'Modalità ta\' qari biss. Id-dejta hija sinkronizzata mis-server prinċipali.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Qed tara bħala',
      loggedInAs: 'dħalt bħala {{nation}}',
      returnTo: 'Lura għal-{{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Fittex paġni, talbiet, trasporti...',
      searching: 'Qed ifittex...',
      noResults: 'L-ebda riżultati għal "{{query}}"',
      navigate: 'Innaviga',
      select: 'Agħżel',
      close: 'Agħlaq',
      pages: {
        dashboard: 'Dashboard',
        requests: 'Talbiet',
        transports: 'Trasporti',
        map: 'Mappa',
        myPatients: 'Il-pazjenti tiegħi',
        flowDiagram: 'Dijagramma tal-fluss',
        statistics: 'Statistika',
        assets: 'Assi',
        startPoints: 'Punti tat-tluq / Ċentri',
        treatmentFacilities: 'Faċilitajiet ta\' kura',
        users: 'Utenti',
        settings: 'Settings',
        auditLogs: 'Reġistri tal-awditjar',
        exerciseControl: 'Kontroll tal-eżerċizzju',
        dataSync: 'Sinkronizzazzjoni tad-dejta',
        patientImport: 'Importazzjoni ta\' pazjenti',
        notifications: 'Notifiki',
        documentation: 'Dokumentazzjoni',
      },
      actions: {
        importPatientsJson: 'Importa Pazjenti (JSON)',
        importPatientsExcel: 'Importa Pazjenti (Excel)',
        importUsers: 'Importa Utenti (Excel)',
        importAssetTemplates: 'Importa Mudelli ta\' Assi (Excel)',
        importDayTemplates: 'Importa Dħul ta\' Mudell tal-Jum (Excel)',
        exportRequests: 'Esporta Talbiet (Excel)',
        exportPatients: 'Esporta Pazjenti (Excel)',
        exportUsers: 'Esporta Utenti (Excel)',
        exportCredentials: 'Esporta Kredenzjali (PDF)',
        exportAuditExcel: 'Esporta Reġistru tal-Awditjar (Excel)',
        exportAuditPdf: 'Esporta Reġistru tal-Awditjar (PDF)',
        pagePatientImport: 'Paġna tal-importazzjoni tal-pazjenti',
        pageRequestDetail: 'Paġna tad-dettalji tat-talba',
        pageUsers: 'Paġna tal-ġestjoni tal-utenti',
        pageAssetTemplates: 'Paġna tal-mudelli tal-assi',
        pageDayTemplates: 'Paġna tal-mudelli tal-jum',
        pageRequests: 'Paġna tal-lista tat-talbiet',
        pageAuditLogs: 'Paġna tar-reġistru tal-awditjar',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Is-sessjoni qed tiskadi',
      message: 'Is-sessjoni tiegħek tiskadi fi <strong>{{time}}</strong>. Jekk jogħġbok, issejvja x-xogħol tiegħek u erġa\' idħol biex tkompli.',
      dismiss: 'Warrab',
      logoutNow: 'Oħroġ issa',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Agħżel 4 żoni tal-ħin',
      configure: 'Ikkonfigura ż-żoni tal-ħin',
      reset: 'Irrisettja',
      apply: 'Applika',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Agħżel post',
      latitude: 'Latitudni',
      longitude: 'Lonġitudni',
      clickToSelect: 'Ikklikkja fuq il-mappa biex tagħżel post',
    },
    // Modal
    modal: {
      close: 'Agħlaq',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Paġna ewlenija',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Manutenzjoni tas-sistema',
    message: 'Is-sistema qed tiġi rrisettjata għall-ġurnata tal-eżerċizzju li jmiss. Jekk jogħġbok, stenna sakemm il-proċess jitlesta.',
    autoRefresh: 'Din il-paġna taġġorna awtomatikament meta s-sistema tkun disponibbli mill-ġdid.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Mill-inqas 10 karattri',
    uppercase: '1 ittra kbira',
    lowercase: '1 ittra żgħira',
    digit: '1 ċifra',
    special: '1 karattru speċjali',
  },
};

export default mt;
